import React, {Component} from 'react'
import styled from 'styled-components'
import * as emailjs from 'emailjs-com'
import '../assests/css/Contact.css'


    export const BodyCta = styled.div 
`
display:flex;
flex-direction:column;
align-items:center;
width: 950px;
height:fit-content;
margin: 15px auto;
padding-bottom: 75px;
border:1px dotted #a39274;
box-shadow: 0 -1px 0 #e0e0e0, 0 0 2px rgba(0, 0, 0, 0.12),
0 2px 4px rgba(0, 0, 0, 0.24); 

@media(max-width:900px) {
  width:100%;
  margin:0 auto;
  padding-bottom:50px;`



  class Contact extends Component {
    state= {
        name:'',
        company:'',
        email:'',
        phone:'',
        message:''
    }

  
    handleSubmit(e)  {
        e.preventDefault()
        window.alert("Thank you for the message");
        const {name, company, email, phone, message} = this.state

        let templateParams = {
            from_name: name,
            to_name:'Kim',
            email:email,
            company:company,
            phone:phone,
            message_html:message

        }

        emailjs.send(
            'ksemenza247',
            'template_71DraddT',
             templateParams,
            'user_zQcwJBt4fbBhWpc1Dahw6'
           )
           this.resetForm()
       }
      resetForm() {
          this.setState({
            name: '',
            email: '',
            company: '',
            phone: '',
            message: '',
          })
        }

        handleChange = (param, e) => {
            this.setState({[param]: e.target.value}
                )
                console.log(e.target.value)
        }
        

    render(){
  
   

    return (
        <div className='contact-wrap'>
         
            <BodyCta className='cta-wrap'>
                <h2 className='contact-h2'>Contact</h2>
               <div className='about-header-wrap'>
             
                   
                  
                    
 </div>
 <div className="contact-form-cta">

     <form onSubmit={this.handleSubmit.bind(this)} className='contact-form'>
         <div className='field-cta'>
         <label>Name</label>
         <input required type='text' value={this.state.name}     onChange={this.handleChange.bind(this, 'name')} name='name' placeholder='Name'></input>
         </div>
         <div className='field-cta'>
         <label>Company</label>
         <input type='text'  value={this.state.company}     onChange={this.handleChange.bind(this, 'company')} name='company' placeholder='Company'></input>
         </div>
         <div className='field-cta'>
         <label>Email</label>
         <input required type='email'  value={this.state.email}     onChange={this.handleChange.bind(this, 'email')} name='email' placeholder='Email'></input>
         </div>
         <div className='field-cta'>
         <label>Phone</label>
         <input type='phone'  value={this.state.phone} name='phone'     onChange={this.handleChange.bind(this, 'phone')} placeholder='Phone'></input>
         </div>
         <div className='field-cta'>
         <label>Message</label>
         <textarea type='textbox' name='details' value={this.state.message}     onChange={this.handleChange.bind(this, 'message')} placeholder='Message'/>
                  </div>
                  <button className='submit-btn trigger'>Submit</button>       
     </form>

  
 </div>
        </BodyCta>
        
        </div>
    )
    }
}

export default Contact

